import React from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import type { PagesQuery } from '../../graphql/generated/schema';
import { BlockContainer } from '../../components/layouts';
import { constructClassName } from '../../utils/constructClassName';
import styles from './styles.module.scss';

export const Lists: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Lists'>> = ({
  list: lists,
  blockSettings,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
    className={constructClassName([
      styles.container,
    ])}
  >
    {
      lists?.map((list) => (
        <div
          key={list.id}
          className={styles.containerInner}
        >
          <p className={styles.listTitle}>{list.title}</p>
          <ul className={styles.ul}>
            {list.items?.map((item) => (
              <li
                key={item.id}
                className={constructClassName([
                  styles.listItem,
                  styles[list.color as keyof typeof styles],
                ])}
              >
                <p className={styles.content}>
                  {item.content}
                </p>
              </li>
            ))}
          </ul>
        </div>
      ))
    }
  </BlockContainer>
);
